import React from 'react';
import {Form, FormControl, FormGroup} from "react-bootstrap";
import {useTranslation} from "react-i18next";

const VolunteerApplicationDescriptions = (props) => {

  const { t } = useTranslation('volunteer-application');

  const translateError = (errorCode, values) => {
    if (errorCode !== undefined) {
      return t('new-volunteer-capture.error.' + errorCode, values);
    } else {
      return '';
    }
  }

  return <div id="volunteer-application-approval-descriptions">
    <Form>
      <Form.Row>
        <FormGroup controlId="selfDescription" className="col-sm mb-3">
          <Form.Label>{t('volunteer-application.form.self-description')}</Form.Label>
          <FormControl type="text" as={"textarea"} rows="5" name="selfDescription"
                       className="form-control-user"
                       value={props.values.selfDescription || ''}
                       onChange={props.handleChange} onBlur={props.handleBlur}
                       isInvalid={props.touched.selfDescription && props.errors.selfDescription}/>
          <Form.Control.Feedback type="invalid">{translateError(props.errors.selfDescription)}</Form.Control.Feedback>
        </FormGroup>
      </Form.Row>

      <Form.Row>
        <FormGroup controlId="careerReasons" className="col-sm mb-3">
          <Form.Label>{t('volunteer-application.form.career-reasons')}</Form.Label>
          <FormControl type="text" as={"textarea"} rows="5" name="careerReasons"
                       className="form-control-user"
                       value={props.values.careerReasons || ''}
                       onChange={props.handleChange} onBlur={props.handleBlur}
                       isInvalid={props.touched.careerReasons && props.errors.careerReasons}/>
          <Form.Control.Feedback type="invalid">{translateError(props.errors.careerReasons)}</Form.Control.Feedback>
        </FormGroup>
      </Form.Row>

      <Form.Row>
        <FormGroup controlId="joiningReasons" className="col-sm mb-3">
          <Form.Label>{t('volunteer-application.form.joining-reasons')}</Form.Label>
          <FormControl type="text" as={"textarea"} rows="5" name="joiningReasons"
                       className="form-control-user"
                       value={props.values.joiningReasons || ''}
                       onChange={props.handleChange} onBlur={props.handleBlur}
                       isInvalid={props.touched.joiningReasons && props.errors.joiningReasons}/>
          <Form.Control.Feedback type="invalid">{translateError(props.errors.joiningReasons)}</Form.Control.Feedback>
        </FormGroup>
      </Form.Row>
    </Form>
  </div>
}

export default VolunteerApplicationDescriptions;